// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"feedbackCard_mainContainer__Gpwvs"};